import {
    ADD_BANK_ACCOUNT_START,
    ADD_BANK_ACCOUNT_SUCCESS,
    ADD_BANK_ACCOUNT_FAILURE,
    GET_BANK_ACCOUNT_START,
    GET_BANK_ACCOUNT_SUCCESS,
    GET_BANK_ACCOUNT_FAILURE,
    DELETE_BANK_ACCOUNT_START,
    DELETE_BANK_ACCOUNT_SUCCESS,
    DELETE_BANK_ACCOUNT_FAILURE,
    MAKE_DEFAULT_BANK_ACCOUNT_START,
    MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS,
    MAKE_DEFAULT_BANK_ACCOUNT_FAILURE,
    VIEW_BANK_ACCOUNT_START,
    VIEW_BANK_ACCOUNT_SUCCESS,
    VIEW_BANK_ACCOUNT_FAILURE,
    WITHIN_PAY_USER_LIST_START,
    WITHIN_PAY_USER_LIST_SUCCESS,
    WITHIN_PAY_USER_LIST_FAILURE,
    CREATE_WITHIN_PAY_USER_START,
    CREATE_WITHIN_PAY_USER_SUCCESS,
    CREATE_WITHIN_PAY_USER_FAILURE,
    DELETE_WITHIN_PAY_USER_START,
    DELETE_WITHIN_PAY_USER_SUCCESS,
    DELETE_WITHIN_PAY_USER_FAILURE,
    SINGLE_VIEW_WITHIN_PAY_USER_FAILURE,
    SINGLE_VIEW_WITHIN_PAY_USER_START,
    SINGLE_VIEW_WITHIN_PAY_USER_SUCCESS,
    WHITELIST_ADDRESS_LIST_START,
    WHITELIST_ADDRESS_LIST_SUCCESS,
    WHITELIST_ADDRESS_LIST_FAILURE,
    CREATE_WHITELIST_ADDRESS_START,
    CREATE_WHITELIST_ADDRESS_SUCCESS,
    CREATE_WHITELIST_ADDRESS_FAILURE,
    DELETE_WHITELIST_ADDRESS_START,
    DELETE_WHITELIST_ADDRESS_SUCCESS,
    DELETE_WHITELIST_ADDRESS_FAILURE,
    SINGLE_VIEW_WHITELIST_ADDRESS_FAILURE,
    SINGLE_VIEW_WHITELIST_ADDRESS_START,
    SINGLE_VIEW_WHITELIST_ADDRESS_SUCCESS,
    SEND_MONEY_WITHIN_PAY_START,
    SEND_MONEY_WITHIN_PAY_SUCCESS,
    SEND_MONEY_WITHIN_PAY_FAILURE,
    STATIC_EXCHANGE_RATE_START,
    STATIC_EXCHANGE_RATE_SUCCESS,
    STATIC_EXCHANGE_RATE_FAILURE,
    STATIC_EMAIL_LIST_START,
    STATIC_EMAIL_LIST_SUCCESS,
    STATIC_EMAIL_LIST_FAILURE,
    BVNK_FEES_START,
    BVNK_FEES_SUCCESS,
    BVNK_FEES_FAILURE,
    SDK_KEY_GENERATE_START,
    SDK_KEY_GENERATE_SUCCESS,
    SDK_KEY_GENERATE_FAILURE,
    WITHDRAWAL_DOWNLOAD_START,
    WITHDRAWAL_DOWNLOAD_SUCCESS,
    WITHDRAWAL_DOWNLOAD_FAILURE,
    VERIFY_CODE_RESET_PASSWORD_START,
    VERIFY_CODE_RESET_PASSWORD_SUCCESS,
    VERIFY_CODE_RESET_PASSWORD_FAILURE,
    ACCEPT_INVITE_START,
    ACCEPT_INVITE_SUCCESS,
    ACCEPT_INVITE_FAILURE,

} from "./ActionConstant";

// Add bank account actions.

export function addBankAccountStart(data) {
    return {
        type: ADD_BANK_ACCOUNT_START,
        data,
    };
}

export function addBankAccountSuccess(data) {
    return {
        type: ADD_BANK_ACCOUNT_SUCCESS,
        data,
    };
}

export function addBankAccountFailure(error) {
    return {
        type: ADD_BANK_ACCOUNT_FAILURE,
        error,
    };
}

// Get bank account actions.

export function getBankAccountStart(data) {
    return {
        type: GET_BANK_ACCOUNT_START,
        data,
    };
}

export function getBankAccountSuccess(data) {
    return {
        type: GET_BANK_ACCOUNT_SUCCESS,
        data,
    };
}

export function getBankAccountFailure(error) {
    return {
        type: GET_BANK_ACCOUNT_FAILURE,
        error,
    };
}
// Delete bank account actions.

export function deleteBankAccountStart(data) {
    return {
        type: DELETE_BANK_ACCOUNT_START,
        data,
    };
}

export function deleteBankAccountSuccess(data) {
    return {
        type: DELETE_BANK_ACCOUNT_SUCCESS,
        data,
    };
}

export function deleteBankAccountFailure(error) {
    return {
        type: DELETE_BANK_ACCOUNT_FAILURE,
        error,
    };
}


// Make default bank account actions.

export function makeDefaultBankAccountStart(data) {
    return {
        type: MAKE_DEFAULT_BANK_ACCOUNT_START,
        data,
    };
}

export function makeDefaultBankAccountSuccess(data) {
    return {
        type: MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS,
        data,
    };
}

export function makeDefaultBankAccountFailure(error) {
    return {
        type: MAKE_DEFAULT_BANK_ACCOUNT_FAILURE,
        error,
    };
}

// View bank account actions.

export function viewBankAccountStart(data) {
    return {
        type: VIEW_BANK_ACCOUNT_START,
        data,
    };
}

export function viewBankAccountSuccess(data) {
    return {
        type: VIEW_BANK_ACCOUNT_SUCCESS,
        data,
    };
}
export function viewBankAccountFailure(error) {
    return {
        type: VIEW_BANK_ACCOUNT_FAILURE,
        error,
    };
}

// Within pay user list actions.
export function withinPayUserListStart(data) {
    return {
        type: WITHIN_PAY_USER_LIST_START,
        data,
    };
}   
export function withinPayUserListSuccess(data) {
    return {
        type: WITHIN_PAY_USER_LIST_SUCCESS,
        data,
    };
}
export function withinPayUserListFailure(error) {
    return {
        type: WITHIN_PAY_USER_LIST_FAILURE,
        error,
    };
}

export function createWithinPayUserStart(data) {
    return {
        type: CREATE_WITHIN_PAY_USER_START,
        data,
    };
}
export function createWithinPayUserSuccess(data) {
    return {
        type: CREATE_WITHIN_PAY_USER_SUCCESS,
        data,
    };
}
export function createWithinPayUserFailure(error) {
    return {
        type: CREATE_WITHIN_PAY_USER_FAILURE,
        error,
    };
}

export function deleteWithinPayUserStart(data) {
    return {
        type: DELETE_WITHIN_PAY_USER_START,
        data,
    };
}
export function deleteWithinPayUserSuccess(data) {
    return {
        type: DELETE_WITHIN_PAY_USER_SUCCESS,
        data,
    };
}
export function deleteWithinPayUserFailure(error) {
    return {
        type: DELETE_WITHIN_PAY_USER_FAILURE,
        error,
    };
}

export function singleViewWithinPayUserStart(data) {
    return {
        type: SINGLE_VIEW_WITHIN_PAY_USER_START,
        data,
    };
}
export function singleViewWithinPayUserSuccess(data) {
    return {
        type: SINGLE_VIEW_WITHIN_PAY_USER_SUCCESS,
        data,
    };
}
export function singleViewWithinPayUserFailure(error) {
    return {
        type: SINGLE_VIEW_WITHIN_PAY_USER_FAILURE,
        error,
    };
}

export function sendMoneyWithinPayStart(data) {
    return {
        type: SEND_MONEY_WITHIN_PAY_START,
        data,
    };
}
export function sendMoneyWithinPaySuccess(data) {
    return {
        type: SEND_MONEY_WITHIN_PAY_SUCCESS,
        data,
    };
}
export function sendMoneyWithinPayFailure(error) {
    return {
        type: SEND_MONEY_WITHIN_PAY_FAILURE,
        error,
    };
}

// WHITELIST ADDRESS actions.
export function whitelistAddressListStart(data) {
    return {
        type: WHITELIST_ADDRESS_LIST_START,
        data,
    };
}   
export function whitelistAddressListSuccess(data) {
    return {
        type: WHITELIST_ADDRESS_LIST_SUCCESS,
        data,
    };
}
export function whitelistAddressListFailure(error) {
    return {
        type: WHITELIST_ADDRESS_LIST_FAILURE,
        error,
    };
}

export function createWhitelistAddressStart(data) {
    return {
        type: CREATE_WHITELIST_ADDRESS_START,
        data,
    };
}
export function createWhitelistAddressSuccess(data) {
    return {
        type: CREATE_WHITELIST_ADDRESS_SUCCESS,
        data,
    };
}
export function createWhitelistAddressFailure(error) {
    return {
        type: CREATE_WHITELIST_ADDRESS_FAILURE,
        error,
    };
}

export function deleteWhitelistAddressStart(data) {
    return {
        type: DELETE_WHITELIST_ADDRESS_START,
        data,
    };
}
export function deleteWhitelistAddressSuccess(data) {
    return {
        type: DELETE_WHITELIST_ADDRESS_SUCCESS,
        data,
    };
}
export function deleteWhitelistAddressFailure(error) {
    return {
        type: DELETE_WHITELIST_ADDRESS_FAILURE,
        error,
    };
}

export function singleViewWhitelistAddressStart(data) {
    return {
        type: SINGLE_VIEW_WHITELIST_ADDRESS_START,
        data,
    };
}
export function singleViewWhitelistAddressSuccess(data) {
    return {
        type: SINGLE_VIEW_WHITELIST_ADDRESS_SUCCESS,
        data,
    };
}
export function singleViewWhitelistAddressFailure(error) {
    return {
        type: SINGLE_VIEW_WHITELIST_ADDRESS_FAILURE,
        error,
    };
}

// Static CAse

export function staticExchangeRateStart(data) {
    return {
        type: STATIC_EXCHANGE_RATE_START,
        data,
    };
}
export function staticExchangeRateSuccess(data) {
    return {
        type: STATIC_EXCHANGE_RATE_SUCCESS,
        data,
    };
}
export function staticExchangeRateFailure(error) {
    return {
        type: STATIC_EXCHANGE_RATE_FAILURE,
        error,
    };
}

export function staticEmailListStart(data) {
    return {
        type: STATIC_EMAIL_LIST_START,
        data,
    };
}
export function staticEmailListSuccess(data) {
    return {
        type: STATIC_EMAIL_LIST_SUCCESS,
        data,
    };
}
export function staticEmailListFailure(error) {
    return {
        type: STATIC_EMAIL_LIST_FAILURE,
        error,
    };
}

// BVNK Fees

export function bvnkFeesStart(data) {
    return {
        type: BVNK_FEES_START,
        data,
    };
}
export function bvnkFeesSuccess(data) {
    return {
        type: BVNK_FEES_SUCCESS,
        data,
    };
}
export function bvnkFeesFailure(error) {
    return {
        type: BVNK_FEES_FAILURE,
        error,
    };
}

// SDK Key

export function sdkKeyGenerateStart(data) {
    return {
        type: SDK_KEY_GENERATE_START,
        data,
    };
}
export function sdkKeyGenerateSuccess(data) {
    return {
        type: SDK_KEY_GENERATE_SUCCESS,
        data,
    };
}
export function sdkKeyGenerateFailure(error) {
    return {
        type: SDK_KEY_GENERATE_FAILURE,
        error,
    };
}

// Single Transaction Download

export function withdrawalDownloadStart(data) {
    return {
        type: WITHDRAWAL_DOWNLOAD_START,
        data,
    };
}
export function withdrawalDownloadSuccess(data) {
    return {
        type: WITHDRAWAL_DOWNLOAD_SUCCESS,
        data,
    };
}
export function withdrawalDownloadFailure(error) {
    return {
        type: WITHDRAWAL_DOWNLOAD_FAILURE,
        error,
    };
}

// Verify Reset Password Code

export function verifyCodeResetPasswordStart(data) {
    return {
        type: VERIFY_CODE_RESET_PASSWORD_START,
        data,
    };
}
export function verifyCodeResetPasswordSuccess(data) {
    return {
        type: VERIFY_CODE_RESET_PASSWORD_SUCCESS,
        data,
    };
}
export function verifyCodeResetPasswordFailure(error) {
    return {
        type: VERIFY_CODE_RESET_PASSWORD_FAILURE,
        error,
    };
}

export function acceptInviteStart(data) {
    return {
        type: ACCEPT_INVITE_START,
        data,
    };
}
export function acceptInviteSuccess(data) {
    return {
        type: ACCEPT_INVITE_SUCCESS,
        data,
    };
}
export function acceptInviteFailure(error) {
    return {
        type: ACCEPT_INVITE_FAILURE,
        error,
    };
}